// Service Worker Registration with Clean Update Mechanism
// Registers SW, detects updates, and notifies the app when a new version is available.

export function registerServiceWorker(onUpdateAvailable) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js');

        // Check for updates every 5 minutes (keeps PWA fresh without aggressive polling)
        setInterval(() => {
          registration.update();
        }, 5 * 60 * 1000);

        // Detect new service worker waiting to activate
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available — notify the app
              if (onUpdateAvailable) {
                onUpdateAvailable(registration);
              }
            }
          });
        });

        // Handle controller change (new SW activated) — reload for fresh content
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (!refreshing) {
            refreshing = true;
            window.location.reload();
          }
        });

      } catch (error) {
        console.error('SW registration failed:', error);
      }
    });
  }
}

export function applyUpdate(registration) {
  if (registration && registration.waiting) {
    registration.waiting.postMessage('SKIP_WAITING');
  }
}
